/* eslint-disable array-callback-return */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-plusplus */
/* eslint-disable no-unused-expressions */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedNumber, IntlProvider } from 'react-intl';
import { Link } from 'react-router-dom';
import { salonSolutionFilter } from '../../../utils';
import {
  Wrapper,
  ContentContainer,
  TitleText,
  DescriptionText,
  ProgramListContainer,
  ProgramRow,
  ProgramImage,
  ProgramContent,
  ProgramContentColumn,
  ProgramContentRow,
  ProgramTitle,
  ProgramName,
  CareLabel,
  PowerContainer,
  PowerTitle,
  PowerValueContainer,
  TimePriceContainer,
  ProgramTime,
  ProgramPrice,
  SCALP_CARE,
  HAIR_CARE,
  HAIR_AND_SCALP_CARE,
  PromotionLabel,
  LabelText,
} from './SalonProgramPage.style';
import Image from '../../../components/ContentfulImage';
import Placeholder from '../../../components/Placeholder';

class SalonProgramPage extends React.Component {
  state = {};

  renderPower = power => {
    const indents = [];
    for (let i = 0; i < 4; i++) {
      if (i < power) {
        indents.push(<li key={i} className="active" />);
      } else {
        indents.push(<li key={i} />);
      }
    }
    return indents;
  };

  renderPlaceholder = () => {
    const count = 2;
    const phList = [];

    for (let i = 0; i < count; i++) {
      phList.push(
        <ProgramRow key={i}>
          <ProgramImage>
            <Placeholder w="240px" h="100%" />
          </ProgramImage>
          <ProgramContent>
            <Placeholder w="290px" h="50px" />
            <ProgramName>
              <Placeholder w="135px" h="20px" />
            </ProgramName>
            <PowerContainer>
              <PowerTitle>
                <Placeholder w="100%" h="100%" />
              </PowerTitle>
              <PowerValueContainer>
                <Placeholder w="100%" h="100%" />
              </PowerValueContainer>
            </PowerContainer>
            <TimePriceContainer>
              <ProgramTime>
                <Placeholder w="24px" h="12px" />
              </ProgramTime>
              <ProgramPrice>
                <Placeholder w="37px" h="12px" />
              </ProgramPrice>
            </TimePriceContainer>
          </ProgramContent>
          <CareLabel color="lightgrey">
            <LabelText dangerouslySetInnerHTML={{ __html: '' }} />
          </CareLabel>
        </ProgramRow>
      );
    }

    return phList;
  };

  renderPrice = (price, authSalonSettingData, locale) => {
    if (
      price &&
      authSalonSettingData &&
      authSalonSettingData.basicSettings &&
      authSalonSettingData.basicSettings.currencyCode
    ) {
      return (
        <IntlProvider locale={locale.split('_')[0]}>
          <FormattedNumber value={price} style="currency" currency={authSalonSettingData.basicSettings.currencyCode} />
        </IntlProvider>
      );
    }
    return null;
  };

  render() {
    const { authSalonSettingData, copy, locale, salonSolutionData, screenSize } = this.props;
    const { title, description, hairCare, scalpCare, hairAndScalpCare, result } =
      salonSolutionFilter(salonSolutionData, authSalonSettingData) || [];

    const ImageP = ({ program }) => (
      <ProgramImage>
        {!!program.image && (
          <Image
            src={program.image}
            options={{
              w: ['118px', '240px'],
              h: '100%',
              objectFit: 'contain',
            }}
          />
        )}
      </ProgramImage>
    );

    const PowerP = ({ program, theme }) => (
      <React.Fragment>
        {program.features.map((feature, index) => (
          <PowerContainer key={index}>
            {feature.name && <PowerTitle>{feature.name}</PowerTitle>}
            {feature.value && (
              <PowerValueContainer theme={theme} color={program.color}>
                <ul className="powerbar">{this.renderPower(feature.value)}</ul>
              </PowerValueContainer>
            )}
          </PowerContainer>
        ))}
        <TimePriceContainer>
          <ProgramTime>
            {program.salonSetting &&
              program.salonSetting.operationTime &&
              `${program.salonSetting.operationTime || 0} ${copy.common.minute || ''} `}
          </ProgramTime>
          <ProgramPrice>
            {program.salonSetting && this.renderPrice(program.salonSetting.price, authSalonSettingData, locale)}
            {/* {program.salonSetting.price && `${program.salonSetting.price || 0} 円`} */}
          </ProgramPrice>
        </TimePriceContainer>
      </React.Fragment>
    );

    const TitleP = ({ program }) => (
      <div>
        {program.promotionText && <PromotionLabel>{program.promotionText}</PromotionLabel>}
        {program.title && <ProgramTitle hasPromotionText={program.promotionText}>{program.title}</ProgramTitle>}
        {program.salonSetting &&
          program.salonSetting.displayName && <ProgramName>{program.salonSetting.displayName}</ProgramName>}
      </div>
    );

    const ProgramList = ({ theme, list, renderPlaceholder }) => (
      <React.Fragment>
        {(list &&
          list.length > 0 &&
          list.map((program, index) => (
            <Link
              key={index}
              to={`/${locale}/salon-consultation/sublimic/salon-program/${program.slug}`}
              href={`/${locale}/salon-consultation/sublimic/salon-program/${program.slug}`}
            >
              <ProgramRow>
                {screenSize === 0 ? (
                  <React.Fragment>
                    <ProgramContentRow>
                      <ImageP program={program} />
                      <TitleP program={program} />
                    </ProgramContentRow>
                    <PowerP program={program} />
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <ImageP program={program} />
                    <ProgramContentColumn hasPromotionText={program.promotionText}>
                      <TitleP program={program} />
                      <PowerP program={program} />
                    </ProgramContentColumn>
                  </React.Fragment>
                )}
                <CareLabel
                  color={program.color}
                  isTwoLines={theme === HAIR_AND_SCALP_CARE || /Advanced/.test(program.labelText)}
                >
                  <LabelText dangerouslySetInnerHTML={{ __html: program.labelText }} />
                </CareLabel>
              </ProgramRow>
            </Link>
          ))) ||
          (!result && renderPlaceholder && this.renderPlaceholder()) || null}
      </React.Fragment>
    );

    return (
      <React.Fragment>
        <Wrapper>
          <ContentContainer>
            {(title && <TitleText>{title}</TitleText>) || (
              <TitleText>
                <Placeholder w="214px" h="27px" />
              </TitleText>
            )}
            {(description && <DescriptionText>{description}</DescriptionText>) || (
              <DescriptionText>
                <Placeholder w="400px" h="20px" />
              </DescriptionText>
            )}
            <ProgramListContainer>
              {/* PromotionText付きのリスト */}
              <ProgramList theme={HAIR_CARE} list={hairCare.filter(({ promotionText }) => promotionText)} renderPlaceholder />
              <ProgramList theme={SCALP_CARE} list={scalpCare.filter(({ promotionText }) => promotionText)} renderPlaceholder />
              <ProgramList
                theme={HAIR_AND_SCALP_CARE}
                list={hairAndScalpCare.filter(({ promotionText }) => promotionText)}
                renderPlaceholder
              />
              {/* PromotionText無しのリスト */}
              <ProgramList theme={HAIR_CARE} list={hairCare.filter(({ promotionText }) => !promotionText)} />
              <ProgramList theme={SCALP_CARE} list={scalpCare.filter(({ promotionText }) => !promotionText)} />
              <ProgramList
                theme={HAIR_AND_SCALP_CARE}
                list={hairAndScalpCare.filter(({ promotionText }) => !promotionText)}
              />
            </ProgramListContainer>
          </ContentContainer>
        </Wrapper>
      </React.Fragment>
    );
  }
}

SalonProgramPage.defaultProps = {
  copy: {},
  salonSolutionData: {},
  authSalonSettingData: {},
};
SalonProgramPage.propTypes = {
  authSalonSettingData: PropTypes.shape({}),
  copy: PropTypes.shape({}),
  locale: PropTypes.string.isRequired,
  salonSolutionData: PropTypes.shape({}),
  screenSize: PropTypes.number.isRequired,
};
const mapState = state => ({
  authSalonSettingData: state.authSalonSettings,
  copy: state.salonConsultaionSiteOptions.siteCopy,
  locale: state.locale,
  salonSolutionData: state.salonSolutionList,
  screenSize: state.screenSize,
});

export default connect(mapState)(SalonProgramPage);



// WEBPACK FOOTER //
// ./src/pages/SalonConsultationPage/SalonProgramPage/SalonProgramPage.js